import { logout } from "../../utils/cookie";

export async function logoutUser(): Promise<void> {
    try {
        logout();
    } catch (error) {
        console.error(error);
    }
}
